module.exports = __webpack_public_path__ + "img/seamless-email-integration.567b8ba3.jpg";